export const HOME = {
  emergentLink: "emergent-link",
  ctaCatalog: "cta-catalog",
  ctaJournal: "cta-journal",
};

export const NAV = {
  logo: "nav-logo",
  catalog: "nav-catalog",
  authors: "nav-authors",
  journal: "nav-journal",
  about: "nav-about",
  admin: "nav-admin",
  mobileToggle: "nav-mobile-toggle",
};

export const CATALOG = {
  grid: "catalog-grid",
  card: (slug) => `catalog-card-${slug}`,
};

export const BOOK = {
  title: "book-title",
  cover: "book-cover",
  blurb: "book-blurb",
  buyAmazon: "book-buy-amazon",
  buyBookshop: "book-buy-bookshop",
};

export const AUTHOR = {
  card: (slug) => `author-card-${slug}`,
  name: "author-name",
  bio: "author-bio",
};

export const JOURNAL = {
  card: (slug) => `journal-card-${slug}`,
  title: "journal-title",
  body: "journal-body",
};

export const NEWSLETTER = {
  input: "newsletter-input",
  submit: "newsletter-submit",
  success: "newsletter-success",
};

export const ADMIN = {
  loginInput: "admin-login-input",
  loginSubmit: "admin-login-submit",
  logout: "admin-logout",
  tabBooks: "admin-tab-books",
  tabAuthors: "admin-tab-authors",
  tabPosts: "admin-tab-posts",
  tabNewsletter: "admin-tab-newsletter",
  seed: "admin-seed",
  bookForm: "admin-book-form",
  bookTitle: "admin-book-title",
  bookSlug: "admin-book-slug",
  bookAuthor: "admin-book-author",
  bookYear: "admin-book-year",
  bookGenre: "admin-book-genre",
  bookBlurb: "admin-book-blurb",
  bookCover: "admin-book-cover",
  bookAmazon: "admin-book-amazon",
  bookBookshop: "admin-book-bookshop",
  bookFeatured: "admin-book-featured",
  bookSubmit: "admin-book-submit",
  aiBlurb: "admin-ai-blurb",
  authorName: "admin-author-name",
  authorSlug: "admin-author-slug",
  authorBio: "admin-author-bio",
  authorPortrait: "admin-author-portrait",
  authorSubmit: "admin-author-submit",
  postTitle: "admin-post-title",
  postSlug: "admin-post-slug",
  postKicker: "admin-post-kicker",
  postExcerpt: "admin-post-excerpt",
  postBody: "admin-post-body",
  postHero: "admin-post-hero",
  postSubmit: "admin-post-submit",
};
